export const formPageIdentifierClass = 'sitecore-jss-form__page-identifier-field'; 
export const sitecoreFormIdentifier = '.sitecore-jss-form form';